/**
 * @generated SignedSource<<23d6c4674fb4b4a3e5efefe272352f15>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type TeamScheduleAdminTemplateScreenQuery$variables = {
  teamId: string;
};
export type TeamScheduleAdminTemplateScreenQuery$data = {
  readonly currentStore: {
    readonly team: {
      readonly routineTemplates: ReadonlyArray<{
        readonly description: string | null;
        readonly id: string;
        readonly title: string;
      }> | null;
    } | null;
  };
};
export type TeamScheduleAdminTemplateScreenQuery = {
  response: TeamScheduleAdminTemplateScreenQuery$data;
  variables: TeamScheduleAdminTemplateScreenQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "teamId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "teamId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "RoutineTemplate",
  "kind": "LinkedField",
  "name": "routineTemplates",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TeamScheduleAdminTemplateScreenQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": null,
          "concreteType": "Store",
          "kind": "LinkedField",
          "name": "currentStore",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": (v1/*: any*/),
              "concreteType": "Team",
              "kind": "LinkedField",
              "name": "team",
              "plural": false,
              "selections": [
                (v3/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        "action": "THROW"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TeamScheduleAdminTemplateScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "currentStore",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "Team",
            "kind": "LinkedField",
            "name": "team",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a5b010d610ce0f4483932871d38e99ef",
    "id": null,
    "metadata": {},
    "name": "TeamScheduleAdminTemplateScreenQuery",
    "operationKind": "query",
    "text": "query TeamScheduleAdminTemplateScreenQuery(\n  $teamId: ID!\n) {\n  currentStore {\n    team(id: $teamId) {\n      routineTemplates {\n        id\n        description\n        title\n      }\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "10075085fb44f5f0709f8d30816c22d6";

export default node;
